<template>
  <!--
    ベーシックレイアウト

    固定のヘッダ、フッタがあり、中央にコンテンツ（高さ不定）があるレイアウトです。
    分析画面以外は原則これで事足りる想定です。
  -->
  <div>
    <header>
      <app-header
        :title="title"
        :help-icon="helpIcon"
        @moveToMenu="moveToMenu"
        @moveToHelp="moveToHelp"
      ></app-header>
    </header>
    <main>
      <slot></slot>
    </main>
    <footer>
      <app-footer :dark="true"></app-footer>
    </footer>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'

export default {
  components: { AppHeader, AppFooter },
  computed: {
    title() {
      return this.$route.meta.page.title
    },
    helpIcon() {
      return this.$route.meta.page.hasHelp
    },
  },
  methods: {
    moveToMenu() {
      this.$router.push('/')
    },
    moveToHelp() {
      window.open(
        `${process.env.VUE_APP_HELP_SITE_URL_BASE}${
          this.$router.currentRoute.name
        }`,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
$header-height: 72px;

header {
  align-items: center;
  border-bottom: 2px solid var(--color-border);
  display: flex;
  flex-direction: columns;
  background-color: var(--bg-color-primary);
  height: $header-height;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
  justify-content: flex-end;
}

main {
  background: var(--bg-color-primary);
  padding-top: $header-height;
  position: relative;
  width: 100%;
  z-index: 1;
}

footer {
  overflow: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
